import {
    INFORMEIMAGE_LIST,
    INFORMEIMAGE_LISTA,
    INFORMEIMAGE_FILTER,
    INFORMEIMAGE_CREATE,
    INFORMEIMAGE_CREATE_SUCCESS,
    INFORMEIMAGE_LIST_SUCCESS,
    INFORMEIMAGE_REQUEST_FAILED,
    INFORMEIMAGE_UPDATE,
    INFORMEIMAGE_UPDATE_SUCCESS,
    INFORMEIMAGE_READ,
    INFORMEIMAGE_READ_SUCCESS,
    INFORMEIMAGE_DELETE,
    INFORMEIMAGE_DELETE_SUCCESS,
  } from "./actionTypes";
  
  const initialState = {
    informeImage: [],
    informeImageCreated: {},
    informeImageUpdated: {},
    informeImageDeleted: false,
    loading: false,
    error: "",
  };
  
  const informeImage = (state = initialState, action) => {
    switch (action.type) {
      case INFORMEIMAGE_CREATE:
        state = {
          ...state,
          loading: true,
        };
        break;
      case INFORMEIMAGE_LIST:
        state = {
          ...state,
          loading: true,
        };
        break;
      case INFORMEIMAGE_LISTA:
        state = {
          ...state,
          loading: true,
        };
        break;
      case INFORMEIMAGE_FILTER:
        state = {
          ...state,
          loading: true,
        };
        break;
      case INFORMEIMAGE_UPDATE:
        state = {
          ...state,
          loading: true,
        };
        break;
        case INFORMEIMAGE_DELETE:
          state = {
            ...state,
            loading: true,
            informeImageDeleted: false,
          };
          break;
      case INFORMEIMAGE_READ:
        state = {
          ...state,
          loading: true,
        };
        break;
      case INFORMEIMAGE_READ_SUCCESS:
        state = {
          ...state,
          loading: false,
          informeImageCreated: action.payload,
          error: "",
        };
        break;
      case INFORMEIMAGE_CREATE_SUCCESS:
        state = {
          ...state,
          loading: false,
          informeImageCreated: action.payload,
          error: "",
        };
        break;
      case INFORMEIMAGE_LIST_SUCCESS:
        state = {
          ...state,
          loading: false,
          informeImage: action.payload,
          informeImageCreated: {},
          informeImageUpdated: {},
          informeImageDeleted: false,
          error: "",
        };
        break;
      case INFORMEIMAGE_UPDATE_SUCCESS:
        state = {
          ...state,
          loading: false,
          informeImageUpdated: action.payload,
          error: "",
        };
        break;
        case INFORMEIMAGE_DELETE_SUCCESS:
          state = {
            ...state,
            loading: false,
            informeImageDeleted: true,
            error: "",
          };
          break;
      case INFORMEIMAGE_REQUEST_FAILED:
        state = {
          ...state,
          loading: false,
          error: action.payload,
        };
        break;
      default:
        state = { ...state };
        break;
    }
    return state;
  };
  
  export default informeImage;
  